import { Paper } from '@mui/material';
import { Title } from './Title';
import { GeneralDetails } from './GeneralDetails';
import { useIsDesktop } from 'Hooks';

export const CommanderDetails = () => {
  const isDesktop = useIsDesktop();
  return (
    <Paper
      sx={{
        width: isDesktop ? '576px' : '100%',
        ml: isDesktop ? '-88px' : '0',
        borderRadius: '8px',
        border: '1px solid #00000014',
        boxShadow: 'none',
        bgcolor: '#F8F8F8',
        p: isDesktop ? '32px 88px 32px 88px' : '24px 16px',
        display: 'flex',
        flexFlow: 'column',
        gap: '24px',
      }}
    >
      <Title />
      <GeneralDetails />
    </Paper>
  );
};
